export default function throttle(callback, wait, context = this) {
    let timeout = null;
    let callbackArgs = null;

    const later = () => {
        callback.apply(context, callbackArgs);
        timeout = null;
    };

    return function () {
        if (!timeout) {
            callbackArgs = arguments; // eslint-disable-line prefer-rest-params
            timeout = setTimeout(later, wait);
        }
    };
}



// WEBPACK FOOTER //
// ./src/js/utils/throttle.js